import React, { ReactElement } from "react";
import { FormikProps } from "formik";
import { getFinancieringsbehoefteTextResources } from "../infra/financieringsbehoefte-resources";
import { advieskostenBemiddelingsvergoedingSideEffects } from "./advieskosten-bemiddelingsvergoeding-modal-side-effects";
import { ISWSideEffects } from "../../shared/components/isw-side-effects/isw-side-effects";
import {
  LabeledCurrencyInput,
  LabeledBevestigingInput,
  LabeledNumberInput,
  BerekenCurrencyInput
} from "adviesbox-shared";
import AdviesBoxFormik from "../../shared/utils/adviesbox-formik";
import Modal from "../../shared/components/modal/Modal";
import { AdvieskostenBemiddelingsvergoedingModal as AdvieskostenBemiddelingsvergoedingModalState } from "../infra/financieringsbehoefte-types";
import { advieskostenBemiddelingsvergoedingModalSchema } from "../infra/financieringsbehoefte-schema";

export type AdvieskostenBemiddelingsvergoedingModalData = {
  data: AdvieskostenBemiddelingsvergoedingModalState;
};

type AdvieskostenBemiddelingsvergoedingModalProps = {
  onSave?: (data: AdvieskostenBemiddelingsvergoedingModalState) => void;
  closeModal?: () => void;
};

const AdvieskostenBemiddelingsvergoedingModal = ({
  data,
  onSave,
  closeModal
}: AdvieskostenBemiddelingsvergoedingModalData & AdvieskostenBemiddelingsvergoedingModalProps): ReactElement => {
  const body = (values: AdvieskostenBemiddelingsvergoedingModalState): ReactElement => (
    <>
      <LabeledCurrencyInput
        caption="Advieskosten"
        name="advieskosten"
        readonly={true}
        tooltip={getFinancieringsbehoefteTextResources("TooltipAdvieskosten")}
      />
      <LabeledCurrencyInput
        caption="Bemiddelingsvergoeding geldlening"
        name="bemiddelingsvergoedingGeldlening"
        readonly={true}
        tooltip={getFinancieringsbehoefteTextResources("TooltipBemiddelingsvergoeding")}
      />

      <LabeledCurrencyInput
        caption="Overige bemiddelingsvergoeding"
        name="overigeBemiddelingsvergoeding"
        readonly={true}
        tooltip={getFinancieringsbehoefteTextResources("TooltipOverigeBemiddeling")}
      />
      <LabeledCurrencyInput
        caption="Dossiervergoeding geldlening"
        name="dossiervergoedingGeldlening"
        readonly={true}
        tooltip={getFinancieringsbehoefteTextResources("TooltipDossiervergoeding")}
      />
      <LabeledBevestigingInput caption="Gespreid betalen" name="gespreidBetalen" />
      {values.gespreidBetalen && (
        <>
          <BerekenCurrencyInput
            caption="Advieskosten"
            name="advieskostenGespreid"
            calculate={() => values.advieskosten}
          />
          <BerekenCurrencyInput
            caption="Bemiddelingsvergoeding geldlening"
            name="bemiddelingsvergoedingGeldleningGespreid"
            calculate={() => values.bemiddelingsvergoedingGeldlening}
          />
          <BerekenCurrencyInput
            caption="Overige bemiddelingsvergoeding"
            name="overigeBemiddelingsvergoedingGespreid"
            calculate={() => values.overigeBemiddelingsvergoeding}
          />
          <LabeledNumberInput
            caption="Gespreid betalen over"
            name="gespreidBetalenOver"
            appendChildren={<span className="MiniLabel">Maanden</span>}
            fieldSize={"s"}
          />
        </>
      )}
    </>
  );
  return (
    <AdviesBoxFormik<AdvieskostenBemiddelingsvergoedingModalState>
      initialValues={{ ...data }}
      validationSchema={advieskostenBemiddelingsvergoedingModalSchema}
      createValidationContext={(_, values): AdvieskostenBemiddelingsvergoedingModalState => values}
      onSave={onSave}
      closeModal={closeModal}
      render={({
        values,
        submitForm,
        dirty
      }: FormikProps<AdvieskostenBemiddelingsvergoedingModalState>): ReactElement => (
        <>
          <ISWSideEffects<AdvieskostenBemiddelingsvergoedingModalState>
            sync={advieskostenBemiddelingsvergoedingSideEffects}
          />

          <Modal
            title="Advieskosten / bemiddelingsvergoeding"
            body={body(values)}
            onSubmitClick={submitForm}
            onCancelClick={closeModal}
            isFormDirty={dirty}
          />
        </>
      )}
    />
  );
};

export default AdvieskostenBemiddelingsvergoedingModal;
